/*** Dependecies ***/
import React, {FC} from 'react'
// eslint-disable-next-line
import cx from 'classnames'
/*** Components ***/

/*** Types ***/
type NoticeItem = {
  color: string
  text: string
  time: string
  linkText?: string
  linkUrl?: string
}

type Props = {
  items: NoticeItem[]
  title: string
}

const Notices: FC<Props> = ({items, title}) => {
  return (
    <div className={'card card-stretch'}>
      <div className='card-body px-9 pt-7'>
        <div className='d-flex flex-stack'>
          <h3 className='m-0 fw-bolder fs-3'>Duyurular</h3>
        </div>
        <div className='notices-container'>
          <div className='timeline-label'>
            {items.map((item, index) => (
              <div className='timeline-item' key={index}>
                <div className='timeline-label fw-bolder text-gray-800 fs-6'>{item.time}</div>
                <div className='timeline-badge'>
                  <i className={cx('fa fa-genderless fs-1', item.color)} />
                </div>
                {item.linkText ? (
                  <div
                    className='fw-normal timeline-content text-muted ps-3'
                    dangerouslySetInnerHTML={{
                      __html: `${item.text.replace(
                        item.linkText ?? '',
                        `<a class='text-primary fw-bolder' href='#'>
                      ${item.linkText}
                    </a>`
                      )}`,
                    }}
                  />
                ) : (
                  <div className='fw-normal timeline-content text-muted ps-3'>{item.text}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Notices
